<div class="upload-list">
    <ng-template
        ngFor
        [ngForOf]="files"
        [ngForTemplate]="template">
    </ng-template>
</div>
